// extracted by mini-css-extract-plugin
module.exports = {"teamCard":"teamCard_teamCard__6-9Ae","imgPlaceholder":"teamCard_imgPlaceholder__KRXko","nameText":"teamCard_nameText__3RKbL","label":"teamCard_label__28mPv"};